<div class="logs-snackbar" [ngClass]="'snackbar-' + type">
  <div class="snackbar-content">
    <mat-icon class="snackbar-icon">{{icon}}</mat-icon>
    <span class="snackbar-message" matSnackBarLabel>
      {{message}}
    </span>
  </div>
  <span matSnackBarActions>
    <button mat-button matSnackBarAction (click)="snackBarRef.dismissWithAction()">{{button}}</button>
  </span>
</div>
